/**
 * Whether a libsql URL points at a local `tursodb --sync-server` (dev) rather
 * than cloud Turso. A local server is usually reached over a loopback host
 * (`127.0.0.1` / `localhost` / `[::1]`), on either the `libsql://` or `http(s)://`
 * scheme. Han's development CI also exposes those same local tursodb instances through
 * Cloudflare Tunnel hostnames so hosted Android Maestro can seed the Mac mini's live dev DB.
 * Cloud Turso uses `libsql://…turso.io` or `turso://…turso.io`.
 *
 * Single source of truth for "is this local", used by:
 *   - the shadowed `createClient` in `+http.ts`, which auto-applies the
 *     `close`-stripping pipeline fetch for local URLs;
 *   - consumers that ALSO need to run migrations/transactions transactionlessly
 *     against local tursodb (a separate concern from fetch — local tursodb 0.6.1
 *     rejects the `BEGIN` drizzle issues).
 */
const LOCAL_TURSO_URL_PATTERN =
  /^(?:libsql|https?):\/\/(?:127\.0\.0\.1|localhost|\[::1\]|(?:controlplane\.)?tursodb\.haniverse\.dev)(?::\d+)?/i;

export function isLocalTursoUrl(url: string): boolean {
  return LOCAL_TURSO_URL_PATTERN.test(url);
}
